(function ($) {
  $(document).ready(function () {
    mobileMenu();
  });

  // Menu functions
  function mobileMenu() {
    const init = () => {
      const $el = $(".header-mobile-megamenu");
      const $close = $(".sub-menu__close");

      if ($el.length === 0) {
        return false;
      }

      setupMenuToggles();
      setupMenuLinksWithSubMenus($el);
      setupLowLevelSubMenus($el);

      closeMenuOnFocusWithin($("#site-content"));

      const $closeWholeMenuButton = $("#mobile-menu-close");
      if ($closeWholeMenuButton) {
        $closeWholeMenuButton.on("click", () => {
          closeWholeMenu();
        });
      }

      $close.on("click", (e) => {
        closeSubMenu($(e.target));
        $("#header-mobile-menu").removeClass("submenu-open");
      });
    };

    const setupMenuToggles = () => {
      const $toggleEls = $("#megamenu-mobile > li.menu-item-has-children > a");
      $toggleEls.each((index, el) => {
        addToggleEvent($(el));
      });
    };

    const setupMenuLinksWithSubMenus = ($el) => {
      const $subMenuElements = $el.find(
        "#megamenu-mobile > li.menu-item-has-children"
      );
      $subMenuElements.each((index, el) => {
        var plusButton = "<a class='open-submenu mobile'></a>";
        var added = $(el).append($(plusButton));
        $(added).appendTo(el);
      });

      const $els = $el.find("li.menu-item-has-children > .open-submenu.mobile");
      $els.each((index, el) => {
        setFirstTapToOpenSubMenu($(el));
      });
    };

    const setupLowLevelSubMenus = ($el) => {
      const $subMenuElements = $el.find(
        ".sub-menu-depth-0 > li.menu-item-has-children"
      );

      $subMenuElements.each((index, el) => {
        var plusButton = "<a class='open-submenu-depth-0 mobile'></a>";
        var added = $(el).append($(plusButton));
        $(added).appendTo(el);
      });

      const $els = $el.find(
        "li.menu-item-has-children > .open-submenu-depth-0.mobile"
      );

      // add in links that are # to be able to click on them
      const $links = $el.find(
        "li.menu-item-has-children > a[href='#']"
      );

      $els.each((index, el) => {
        toggleLowLevelSubMenus($(el));
      });

      $links.each((index, el) => {
        $(el).on("click", (e) => {
          e.preventDefault();
          const $parent = $(el).closest(".menu-item");
          if ($parent) {
            const $toggle = $parent.find('.open-submenu-depth-0.mobile');
            if ($toggle) {
              $toggle.click();
            }
          }
        });
      });

    };

    const addToggleEvent = ($el) => {
      $el.on("click", (e) => {
        e.preventDefault();
        $("body").toggleClass("has-open-mobile-menu");
      });
    };

    const toggleLowLevelSubMenus = ($el) => {
      $el.on("click", (e) => {
        e.preventDefault();
        const $submenu = $el.siblings(".sub-menu-depth-1");
        $el.toggleClass("open");
        $submenu.toggleClass("is-open");
      });
    };

    const setFirstTapToOpenSubMenu = ($el) => {
      $el.on("click", (e) => {
        e.preventDefault();
        const $parent = $el.closest(".menu-item");

        if (!$parent.hasClass("is-open")) {
          $el.parent().css("position", "static");
          $el.siblings(".sub-menu").addClass("is-open");
          $el.siblings(".sub-menu").attr("aria-expanded", "true");
        }
        $("#header-mobile-menu").addClass("submenu-open");
      });
    };

    const closeSubMenu = ($el) => {
      $el.parent(".sub-menu").removeClass("is-open");
      $el.parent(".sub-menu").attr("aria-expanded", false);
      $el.closest(".menu-item").css("position", "relative");
    };

    const closeMenuOnFocusWithin = ($el) => {
      $el.on("focusin", () => {
        closeWholeMenu();
      });
    };

    const closeWholeMenu = () => {
      $("#header-mobile-menu").removeClass("active");
        $("body").removeClass("header-mobile-menu-open");
    };

    init();
  }
})(jQuery);
